import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { SoundBoardRequests } from 'src/requests/soundboard';
import { QueryKey, queryRetry } from 'src/utils/react-query';

export function useSoundBoardsQuery() {
  const {
    data: sounds,
    isLoading,
    isFetching,
    refetch,
  } = useQuery([QueryKey.SOUNDBOARD], () => SoundBoardRequests.getSounds(), {
    keepPreviousData: true,
    retry: queryRetry,
  });

  return useMemo(
    () => ({
      sounds: sounds || [],
      isLoading,
      isFetching,
      refetch,
    }),
    [sounds, isLoading, isFetching, refetch],
  );
}
